module.exports = __webpack_public_path__ + "static/media/indexColinas.f520f93c.png";